import { createContext, useContext } from 'react';
import { ApolloError } from '@apollo/client';
import noop from 'utils/noop';
import { MessageType } from 'modules/graphql/types';

export interface MessageTypesQueryContextState {
  errorMessage: string | ApolloError;
  hasError: boolean;
  isLoading: boolean;
  refetch: () => void;
  messageTypes: MessageType[];
}

export const MessageTypesQueryContext = createContext<MessageTypesQueryContextState>({
  errorMessage: '',
  hasError: false,
  isLoading: false,
  refetch: noop,
  messageTypes: [],
});

export const useMessageTypesQueryContext = () => useContext(MessageTypesQueryContext);
